
































































































































interface Form {
  deliveryTime: number;
  serviceCharge: number;
  withdrawTime: number;
  accountinMingDate: number;
  accountinMaxgDate: number;
}
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import storage from 'baimahu/storage';
const { VUE_APP_FCAPI: FCAPI } = process.env;
const VALIDATE = {
  isDeliveryTime: false,
  isServiceCharge: false,
  isWithdrawTime: false,
  isAccountinDate: false,
};

@Component
export default class TradeSetting extends Vue {
  isLoading: boolean = false;
  formItemLayout: any = {
    labelCol: { span: 5 },
    wrapperCol: { span: 19 },
  };
  form: Form = getForm();
  serviceChargeValue: number = 1;
  withdrawTimeValue: number = 1;
  validate: any = VALIDATE;
  deliveryTimeRemark: string = '';
  serviceChargeRemark: string = '';
  withdrawTimeRemark: string = '';
  accountinDateRemark: string = '';

  get api() {
    const profile = storage.getItem('profile') || {};
    const merchant_id = profile.merchant_id || '';
    const API = {
      query: `${FCAPI}/shang/setting/trade/${merchant_id}`,
    };
    return API;
  }

  async query() {
    this.isLoading = true;
    const res: AxiosResponse = await this.$axios.get(this.api.query);
    const remote = res.data;
    if (remote.status !== 200) {
      // 找不到数据就自动新增, 无需提醒
      // this.$message.error(remote.message);
      this.isLoading = false;
      return;
    }
    this.serviceChargeValue = remote.data.withdraw_commission > '0' ? 2 : 1;
    this.withdrawTimeValue = remote.data.withdraw_waiting_time > '0' ? 2 : 1;
    this.form = getForm(remote.data || {});
    this.isLoading = false;
  }

  changeService(e: any) {
    const value = e.target.value;
    if (value === 1) {
      this.validate.isServiceCharge = false;
    } else {
      if (!this.form.serviceCharge) {
        this.serviceChargeRemark = '*请输入提现手续费';
        this.validate.isServiceCharge = true;
        return;
      }
      if (!/(^[1-9]\d*$)/.test(String(this.form.serviceCharge))) {
        this.serviceChargeRemark = '*提现手续费必须为整数';
        this.validate.isServiceCharge = true;
        return;
      }
    }
  }

  changeWithdrawTime(e: any) {
    const value = e.target.value;
    if (value === 1) {
      this.validate.isWithdrawTime = false;
    } else {
      if (this.form.withdrawTime < 1 || this.form.withdrawTime > 30) {
        this.withdrawTimeRemark = '*可提现时间范围为1-30天';
        this.validate.isWithdrawTime = true;
        return;
      }
      if (!/(^[1-9]\d*$)/.test(String(this.form.withdrawTime))) {
        this.withdrawTimeRemark = '*可提现时间必须为整数';
        this.validate.isWithdrawTime = true;
        return;
      }
    }
  }

  updateInput(type: string, key: string) {
    const form = this.form;
    this.validate[type] = !(form as any)[key];
    if (type === 'isDeliveryTime') {
      if (form.deliveryTime < 0 || form.deliveryTime > 30) {
        this.deliveryTimeRemark = '*自动确认收货时间必须在0-30天之间';
        this.validate.isDeliveryTime = true;
        return;
      }
      if (!/(^[0-9]\d*$)/.test(String(form.deliveryTime))) {
        this.deliveryTimeRemark = '*自动确认收货时间必须为整数';
        this.validate.isDeliveryTime = true;
        return;
      }
    }
    if (type === 'isServiceCharge') {
      if (this.serviceChargeValue !== 2) {
        this.validate.isServiceCharge = false;
        return;
      }
      if (!form.serviceCharge) {
        this.serviceChargeRemark = '*请输入提现手续费';
        this.validate.isServiceCharge = true;
        return;
      }
      if (!/(^[1-9]\d*$)/.test(String(form.serviceCharge))) {
        this.serviceChargeRemark = '*提现手续费必须为整数';
        this.validate.isServiceCharge = true;
        return;
      }
    }
    if (type === 'isWithdrawTime') {
      if (this.withdrawTimeValue !== 2) {
        this.validate.isWithdrawTime = false;
        return;
      }
      if (!form.withdrawTime) {
        this.withdrawTimeRemark = '*请输入可提现时间';
        this.validate.isWithdrawTime = true;
        return;
      }
      if (form.withdrawTime < 1 || form.withdrawTime > 30) {
        this.withdrawTimeRemark = '*可提现时间范围为1-30天';
        this.validate.isWithdrawTime = true;
        return;
      }
      if (!/(^[1-9]\d*$)/.test(String(form.withdrawTime))) {
        this.withdrawTimeRemark = '*可提现时间必须为整数';
        this.validate.isWithdrawTime = true;
        return;
      }
    }
    if (type === 'isAccountinDate') {
      if (!form.accountinMingDate || !form.accountinMaxgDate) {
        this.accountinDateRemark = '*请输入预计到账时间';
        this.validate.isAccountinDate = true;
        return;
      }
      if (form.accountinMingDate < 1 || form.accountinMingDate > 30) {
        this.accountinDateRemark = '*预计到账时间范围为1-30天';
        this.validate.isAccountinDate = true;
        return;
      }
      if (form.accountinMaxgDate < 1 || form.accountinMaxgDate > 30) {
        this.accountinDateRemark = '*预计到账时间范围为1-30天';
        this.validate.isAccountinDate = true;
        return;
      }
      if (Number(form.accountinMingDate) > Number(form.accountinMaxgDate)) {
        this.accountinDateRemark = '*最小时间不能大于最大时间';
        this.validate.isAccountinDate = true;
        return;
      }
      if (
        !/(^[1-9]\d*$)/.test(String(form.accountinMingDate)) ||
        !/(^[1-9]\d*$)/.test(String(form.accountinMaxgDate))
      ) {
        this.accountinDateRemark = '*预计到账时间必须为整数';
        this.validate.isAccountinDate = true;
        return;
      }
    }
  }

  async submit() {
    for (const key in this.validate) {
      if (this.validate[key]) {
        this.$message.error('表单填写有误，请仔细检查');
        return;
      }
    }
    const sendData: any = {};
    sendData.auto_confirm_receipt_time = Number(this.form.deliveryTime);
    sendData.withdraw_commission =
      this.serviceChargeValue === 2 ? Number(this.form.serviceCharge) : 0;
    sendData.withdraw_waiting_time =
      this.withdrawTimeValue === 2 ? Number(this.form.withdrawTime) : 0;
    sendData.withdraw_arrival_time_range_min = Number(
      this.form.accountinMingDate
    );
    sendData.withdraw_arrival_time_range_max = Number(
      this.form.accountinMaxgDate
    );

    const res: AxiosResponse = await this.$axios.put(this.api.query, sendData);
    const remote = res.data;
    if (remote.status !== 200) {
      this.$message.error(remote.message);
      this.isLoading = false;
      return;
    }
    this.$message.success('保存成功');
    this.query();
    this.isLoading = false;
  }

  async created() {
    await this.query();
  }
}

function getForm(remote: any = {}): Form {
  return {
    deliveryTime:
      remote.auto_confirm_receipt_time === 0
        ? 0
        : remote.auto_confirm_receipt_time || 7,
    serviceCharge: remote.withdraw_commission || 1,
    withdrawTime: remote.withdraw_waiting_time || 7,
    accountinMingDate: remote.withdraw_arrival_time_range_min || 1,
    accountinMaxgDate: remote.withdraw_arrival_time_range_max || 5,
  };
}
